/**
 * Build a single HTMLElement from an HTML string.
 * Throws if the string doesn't produce exactly one root element.
 */
export const el = (html: string): HTMLElement => {
  const tpl = document.createElement('template');
  tpl.innerHTML = html.trim();
  const node = tpl.content.firstElementChild;
  if (!node || tpl.content.children.length !== 1) {
    throw new Error('el() expects exactly one root element');
  }
  if (!(node instanceof HTMLElement)) {
    throw new Error('el() root must be an HTMLElement');
  }
  return node;
};

/**
 * Escape a string for safe interpolation into HTML text/attribute context.
 */
export const escape = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
